export const filterRequestedSupplementalDocFromCertificate = (requestedSupplementalDocumentation, certificate) => {
  return Object.fromEntries(Object.entries(requestedSupplementalDocumentation || {}).filter(([key]) => {
    return certificate?.coverageType?.includes(key)
  }
  ))
}